import { Component, Input } from '@angular/core';
import { IntegrationState } from 'src/app/proxy/integrations-status';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-integration-state-icon',
  standalone: false,
  templateUrl: './integration-state-icon.component.html',
})
export class IntegrationStateIconComponent extends AppBaseComponent {

  @Input({ required: true }) state: IntegrationState;

  isSuccess(): boolean {
    return this.state === IntegrationState.OK;
  }

  isError(): boolean {
    return this.state === IntegrationState.Error;
  }

  isExecuting(): boolean {
    return this.state === IntegrationState.Executing;
  }

  isPending(): boolean {
    return this.state === IntegrationState.Pending;
  }

  getStateLabel(): string {
    switch (this.state) {
      case IntegrationState.OK:
        return this.l('::OK');
      case IntegrationState.Error:
        return this.l('::Error');
      case IntegrationState.Executing:
        return this.l('::Executing');
      case IntegrationState.Pending:
        return this.l('::Pending');
    }
  }
}
